const animationDuration = '0.2s';
export const slideFromLeft = {
  animation: `fromLeftSlideIn ${animationDuration} ease-out`,
  '@keyframes fromLeftSlideIn': {
    from: {
      transform: 'translateX(-100%)',
    },
    to: {
      transform: 'translateX(0)',
    },
  },
};

export const slideFromRight = {
  animation: `fromRightSlideIn ${animationDuration} ease-out`,
  '@keyframes fromRightSlideIn': {
    from: {
      transform: 'translateX(100%)',
    },
    to: {
      transform: 'translateX(0)',
    },
  },
};
